import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { WithPayItemGlobalId } from 'components/CIMSTable/components/HeaderActionButtons/types'
import SubmittalTrackerProvider from './SubmittalTrackerContext'
import SubmittalTrackerTable from './components/SubmittalTrackerTable'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import { CustomFieldClassType } from '@cims-online/shared'

const SubmittalTracker: React.VFC<WithPayItemGlobalId> = ({
  payItemGlobalId,
}) => (
  <ProjectCustomFieldsProvider
    classType={CustomFieldClassType.ConstructionAdminSubmittal}
  >
    <PayItemSelectProvider>
      <SubmittalTrackerProvider payItemGlobalId={payItemGlobalId}>
        <SubmittalTrackerTable />
      </SubmittalTrackerProvider>
    </PayItemSelectProvider>
  </ProjectCustomFieldsProvider>
)

export default SubmittalTracker
